export enum ContrastColor {
  White = 'white',
  Black = 'black',
}
